import { IApplicationContext } from '../../types/applicationContext';
import {
  fetchPublicMyHomeNewbuildingV2CreateRealty,
  IPublicMyHomeNewbuildingV2CreateRealtyRequest,
} from '../../../common/repositories/price-estimator/my-home/newbuilding/v2/create-realty';
import { createSubmitNewbuildingData } from './mappers';

export const fetchNewbuildingData = async (
  parameters: IPublicMyHomeNewbuildingV2CreateRealtyRequest,
  context: IApplicationContext,
) => {
  try {
    const res = await fetchPublicMyHomeNewbuildingV2CreateRealty({
      parameters,
      httpApi: context.httpApi,
      mappers: createSubmitNewbuildingData(),
    });

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    context.logger.error(error, { message: 'error in fetchPublicMyHomeNewbuildingV1CreateRealty' });

    throw error;
  }
};
